module.exports = "<p>\n  lottery-applicant-view works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/lottery/lottery-applicant-view/lottery-applicant-view.component.html
// module id = ./src/app/allocation/lottery/lottery-applicant-view/lottery-applicant-view.component.html
// module chunks = main